import utils from "./utils"
import storeHelpers from '@/utils/storeHelpers.js';
import error from './error.js';
import { callbackify } from "util";
const moment = require('moment');
moment.tz.setDefault('Africa/Johannesburg');

const funcs = {
  uploadResource: async function(handle, resource, file, callback) {
    var formData = new FormData();

    formData.append('title', resource.title);
    formData.append('category', resource.type);
    formData.append('description', '');
    formData.append('subject', 0);
    formData.append('studyYear', '');
    formData.append('language', '');

    //for already existed resources, modify
    if (!resource.id && resource._id) {
      resource.id = resource._id;
    }
    if (!resource.type && resource.category) {
      resource.type = resource.category;
    }
    
    if (resource.type === "text") {
      resource.text = await new Response(file).text();
      formData.append('text', resource.text);
    } else if (resource.type === "url") {
      formData.append('url', '');
    } else if (resource.type === 'flashcarddeck') {
      formData.append('flashCards', file);
    }

    formData.append("file", file);

    axios.post(handle.$config.get('ecApi') + 'resources?private=true&id=' + resource.id, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      resource.uploading = false;
      callback("200", response);
    }).catch(error => {
      callback("502", error);
    })
  },
  uploadAttachment: function(handle, attachment, callback) {
    var filteredAttachment = funcs.filterAttachmentObject(attachment);
    storeHelpers.addItemToSync(handle, {
      url: handle.$config.get('ecApi') + 'attachments',
      method: "post",
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.parse(JSON.stringify(filteredAttachment))
    })
  },
  createResource: function(filename) {
    var id = 'resource-' + utils.GUID(); 
    var category = utils.determineResourceCategory(filename);
    var resource = {
      "id": id,
      "_id": id,
      "rev": "v" + moment().unix(),
      "type": category,
      "title": filename.substr(0, filename.lastIndexOf('.')),
      "created": moment().unix(),
      "uploading": true,
      "category" : category,
      "private" : true
    };
    return resource;
  },
  createAttachment: function(bookId, section, selector) {
    var id = "attachment-" + utils.GUID();
    var attachment = {
      "groups": null,
      "selector": selector,
      "id": id,
      "_id": id,
      "book": bookId,
      "resource": "resource-" + utils.GUID(),
      "section": section,
      "group": null,
      "private": "true",
      "resourceType": "flashcarddeck"
    };
    return attachment;
  },
  deleteResourceWithAttachments: function(handle, resourceId) {
    storeHelpers.addItemToSync(handle, {
      url: handle.$config.get('ecApi') + 'resources/withAttachments/' + resourceId,
      method: "delete",
      data: {}
    });
  },
  postMyFolderContent: function(handle, myFoldersDataCleaned, callback) {  
    storeHelpers.addItemToSync(handle, {
      url: handle.$config.get('ecApi') + 'freeform/' + utils.uriEncode(handle.$store.state.user.username),
      method: "put",
      data: {
        data: JSON.stringify(myFoldersDataCleaned.data),
        private: true,
        category: 'usercontent'
      }
    })
    callback(200);
  },
  isEndpointAvailable: function(url) {
    return axios.head(url).then(response => {
      return { "status": true, "code": 200 };
    }).catch(error => {   
      console.error(error);
      return { "status": false, "code": 404 };
    })
  },
  filterAttachmentObject: function(attachment) {
    var allowedProperties = ["groups","selector","id","_id","book","resource","section","group","private","resourceType"];
    _.each(Object.keys(attachment), key => {
      if (allowedProperties.indexOf(key) === -1) {
        delete attachment[key];
      }
    });
    return attachment;
  }
}

export default funcs

